// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__CL7VS","title":"Header_title__3b-PO","left":"Header_left__3bxBG","clinicName":"Header_clinicName__3SCHu"};